module.exports = __webpack_public_path__ + "img/p6.e796e90b.svg";